import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useProgram } from 'app/hooks/useProgram';
import { OTP } from 'app/utils/constants/endPoint';
import { removeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { requestApi } from 'app/utils/RestApi';

const MicrositeKonfirmasiBelumRegis = () => {
	const navigate = useNavigate();

	const program = useProgram();

	React.useEffect(() => {
		window.history.replaceState(null, null, "/micrositeKonfirmasiBelumRegis");
		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	const initData = async () => {
		const otp = sessionStorage.getItem("otp_temp")
		if(otp) {
			const {data} = await requestApi(OTP.VERIFY_OTP_REF, {
				data: {
					username: localStorage.getItem('username'),
					otp: otp
				}
			})
			if(data.status !== 'success') {
				sessionStorage.removeItem("otp_temp")
				removeToken()
			}
		}
	}

	return (
		<Div className='custompage'>
			<ContentWrapper>
				<Div className='content-padding'>
					{/* <Div className='back-icon'>
					<KeyboardBackspaceIcon onClick={backHandler} />
					<Div className='flex-justify-start' sx={{ marginLeft: '28px' }}>

					</Div>
				</Div> */}
					<Div className='mt-2'>
						<Typography sx={{ mt: 2 }} fontSize={20} fontWeight={600} textAlign={"center"} color={"black"}>Selamat! Anda telah terdaftar ke dalam {program}</Typography>
						<Div className='dis-flex-center' sx={{ mt: 2 }}>
							<img className='illust-state' src={`${process.env.REACT_APP_IMAGES_PATH}/BelumRegis.svg`} width={265} height={265} />
						</Div>

						<Div className='flex-justify-center' sx={{ mt: 2 }}>
							<ButtonStyled
								btnText={"Ubah Password"}
								sx={{ maxWidth: '451px' }}
								preset={"primary"}
								onClick={() => navigate('/micrositeUbahPassword')}
							/>
						</Div>
					</Div>
				</Div>
			</ContentWrapper>
		</Div>
	);
};

export default MicrositeKonfirmasiBelumRegis;